import type { BasketProposal } from '../../store/modules/interfaces/ProposalBasketStoreState';
import type { TrackingObject } from './types/TagManager';

export default class Proposal {
  private model: BasketProposal;

  constructor(model: BasketProposal) {
    this.model = model;
  }

  get(event: string): TrackingObject | null {
    let trackingObject: TrackingObject | null = null;
    const trackEvent = 'track-event';
    const eventCategory = 'Min side kurv';

    switch (event) {
      case 'proposal-basket-deselect-proposal': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'Fravalg produkt klik',
          eventLabel: `Fravalg - ${this.model.productType}`,
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }

      case 'proposal-basket-select-proposal': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'Aktivt tilvalg produkt klik',
          eventLabel: `Tilvalg - ${this.model.productType}`,
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }

      case 'proposal-basket-remove-proposal': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'Fjern produkt klik',
          eventLabel: `Fjern - ${this.model.productType}`,
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }

      case 'proposal-basket-select-yearly-interval': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'Betalingsfrekvens - Helårlig',
          eventLabel: `${this.model.productType}`,
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }

      case 'proposal-basket-select-halfyearly-interval': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'Betalingsfrekvens - Halvårlig',
          eventLabel: `${this.model.productType}`,
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }

      case 'proposal-basket-select-quarterly-interval': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'Betalingsfrekvens - Kvartårlig',
          eventLabel: `${this.model.productType}`,
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }

      case 'proposal-basket-select-monthly-interval': {
        trackingObject = {
          event: trackEvent,
          eventCategory,
          eventAction: 'Betalingsfrekvens - Månedlig',
          eventLabel: `${this.model.productType}`,
          eventValue: '0',
          eventNoninteraction: true,
          data: null
        };
        break;
      }
    }

    return trackingObject;
  }
}
